import styled from "@emotion/native";
import Text from "../Text";

import { QuizRestartIcon } from "myplan/components/Icon";

export const Container = styled.View({
	display: "flex",
	flexDirection: "column",
	width: "100%",
	alignItems: "center",
	justifyContent: "center",
});

export const Body = styled.View(
	{
		flexDirection: "column",
		width: "100%",
		alignItems: "center",
		justifyContent: "center",
		minHeight: 100,
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.backgroundAccent,
		};
	}
);

export const CtaContainer = styled.View({
	display: "flex",
	flexDirection: "row",
	justifyContent: "center",
	alignContent: "center",
	alignItems: "center",
	marginTop: 12,
	marginBottom: 12,
	marginHorizontal: 12,
});

export const CtaText = styled(Text)({
	maxWidth: 275,
	textAlign: "left",
});

export const RedoIcon = styled(QuizRestartIcon)({
	marginRight: 7,
});

export const LastReviewedOnLabel = styled(Text)({
	textAlign: "center",
	marginHorizontal: 20,
});
